import { useState } from "react";
import { WorkOrderStatus } from "@/gql/graphql";
import { WorkOrderTable } from "@/app/ProDrivers/WorkOrders/Components/WorkOrderTable";
import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";
import { TruckIcon } from "lucide-react";
import { Button } from "@/components/catalyst/button";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { CreateWorkOrderDialog } from "@/app/ProDrivers/WorkOrders/Components/CreateWorkOrderDialog";

export function RelocationProDriversScreen() {
  const relocation = useRelocationRecord();
  const [status, setStatus] = useState<WorkOrderStatus[]>([]);
  const { open } = useDialog(CreateWorkOrderDialog);

  if (!relocation.workOrdersCount) {
    const departureAddress = relocation.departureOffice.address;
    const deliveryAddress = relocation.deliveryOffice.address;

    return (
      <div className="mt-6 flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 px-6 py-16">
        <TruckIcon className="h-12 w-12 text-gray-400" />
        <h3 className="mt-4 text-lg font-medium text-gray-900">
          No Pro Drivers requested
        </h3>
        <p className="mt-2 max-w-md text-center text-sm text-gray-500">
          Need this vehicle moved? Hire a Pro Driver to reposition it for you.
        </p>
        <Button
          color="indigo"
          className="mt-6"
          onClick={() => {
            open({
              initialValues: {
                supplier: { connect: relocation.supplier.id },
                vehicle_type: relocation.vehicle.type,
                currency: relocation.currency,
                relocation: { connect: relocation.id },
                depart_after: relocation.available_from_date,
                deliver_before: relocation.available_to_date,
                ...(departureAddress
                  ? {
                      departureAddress: {
                        upsert: {
                          address_line_1: departureAddress.address_line_1 ?? "",
                          address_line_2: departureAddress.address_line_2 ?? "",
                          city: departureAddress.city ?? "",
                          state: departureAddress.state ?? "",
                          country: departureAddress.country ?? "",
                          postcode: departureAddress.postcode ?? "",
                        },
                      },
                    }
                  : {}),
                ...(deliveryAddress
                  ? {
                      deliveryAddress: {
                        upsert: {
                          address_line_1: deliveryAddress.address_line_1 ?? "",
                          address_line_2: deliveryAddress.address_line_2 ?? "",
                          city: deliveryAddress.city ?? "",
                          state: deliveryAddress.state ?? "",
                          country: deliveryAddress.country ?? "",
                          postcode: deliveryAddress.postcode ?? "",
                        },
                      },
                    }
                  : {}),
              },
            });
          }}
        >
          Request a driver
        </Button>
      </div>
    );
  }

  return (
    <WorkOrderTable
      status={status}
      setStatus={setStatus}
      relocationId={relocation.id}
    />
  );
}
